import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=0e7f33a8&scoped=true"
import script from "./layout-footer.vue?vue&type=script&lang=js"
export * from "./layout-footer.vue?vue&type=script&lang=js"
import style0 from "./layout-footer.vue?vue&type=style&index=0&id=0e7f33a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7f33a8",
  null
  
)

export default component.exports